import React from 'react';
import SzeretetnyelvTeszt from './SzeretetnyelvTeszt';

function App() {
  return (
    <div className="App">
      <SzeretetnyelvTeszt />
    </div>
  );
}

export default App;